export const en = {
    'Player name': 'Nombre de jugador',
    'Add': 'Añadir',
    'Done': 'Hecho'
}
